// @ts-expect-error - Importing from .js.erb file which is not a standard TypeScript file
import * as Routes from 'common/js-route.js.erb';
export default Routes;
